import React, { useEffect, useContext } from 'react';
import Product from './item';
import Data from 'Content/content.json';
import { language, LANG_JP, CLASSIC_LENS_TAB, FRESH_LENS_TAB } from 'Root/constants';
import { isPartnerURL } from 'Root/utils';
import AppContext from '../../../context';
import VMContext from '../../context';
import './Products.scss';
import { definePartner,defineFilter } from 'Root/utils';
import { showCustomFloatButton } from 'Root/constants';

const Products = ({
  handleLensChange,
  recommendedIndex,
  VMImageLoaded,
  resetSelectedMakeup,
}) => {
  const vmContext = useContext(VMContext);
  const {
    lensGuid,
    product,
    looksLoaded,
    updateLensGuid,
    updateFloatButtonURL,
    updateInstagramBackgroundURL,
    updateLook,
    updateRecommendation,
    updateClearLens,
    updateIgnoreRecommendation,
    updateProduct,
    recommendation: { other },
  } = useContext(AppContext);

  const {
    selectedTab,
  } = vmContext;
  const {
    data: {
      productInfo: {
        [language]: { [selectedTab]: lensList },
      },
      looks,
    },
  } = Data;
  const customFloatButtonData = showCustomFloatButton ? Data['data']['customFloatButton'][language][definePartner()] : null;
  const instagramURL = null;

  useEffect(() => {
    let lookKey,
      recommendedLook = null;
    if (!looksLoaded && (selectedTab === CLASSIC_LENS_TAB || selectedTab === FRESH_LENS_TAB)) {
      const isRecommended = recommendedIndex > -1;
      if(lensList[recommendedIndex]) {
        lookKey = isRecommended
          ? lensList[recommendedIndex].recommended_look
          : lensList[product].recommended_look;
        recommendedLook = looks.findIndex((look) => look.icon === lookKey);
        updateLook(recommendedLook);
      }
    }

    return () => {
      if(showCustomFloatButton && isPartnerURL()) {
        updateFloatButtonURL(customFloatButtonData.url);
      }
    };
  }, []);

  const handleLensClick = (lensIndex, item) => {
    if (product !== lensIndex) {
      if (VMImageLoaded) {
        window.YMK.disableCompare();
        window.YMK.reset(); // remove makeup from vm
      }
      resetSelectedMakeup();
    }
    if(showCustomFloatButton && isPartnerURL()) {
      if (item.partner !== undefined && item.partner[definePartner()] !== undefined) {
        updateFloatButtonURL(item.partner[definePartner()]);
      }
      else {
        updateFloatButtonURL(customFloatButtonData.url);
      }
    }
    if(item.instagram !== undefined) {
      updateInstagramBackgroundURL(item.instagram[defineFilter()]);
    }

    updateLensGuid(item.guid, item.key);
    updateProduct(lensIndex, item.id);
    const lookKey = lensList[lensIndex].recommended_look;
    const recommendedLook = looks.findIndex((look) => look.icon === lookKey);
    updateClearLens(false);
    handleLensChange(lensIndex, 1, selectedTab);

    !looksLoaded && updateLook(recommendedLook);
    !looksLoaded &&
      typeof recommendedIndex !== 'undefined' &&
      updateIgnoreRecommendation();
  };
  return (
    <ul className="palette--wrapper">
      {lensList.map((item, index) => {
        const recommended =
          recommendedIndex === index ||
          (recommendedIndex > -1 && other === index);
        return (
          <Product
            key={index}
            item={item}
            recommended={recommended}
            onClick={() => {
              handleLensClick(index, item);
            }}
            active={lensGuid === item.guid && true}
          />
        );
      })}
    </ul>
  );
};

export default Products;
